import React, { Component } from 'react';
import 'brace/ext/searchbox';
import 'brace/ext/language_tools';

import AceEditor from 'react-ace';

class AceComponent extends Component {
  // codeChange = (changes, source) => {
  //   console.log(changes, source);
  //   // this.props.tableChange(this.handsontableData, changes, source);
  // }
  shouldComponentUpdate(nextProps, nextState) {
    return  JSON.stringify(nextProps) !== JSON.stringify(this.props)
  }
  componentDidMount() {
    this.refs[this.props.type].editor.setOption('enableLiveAutocompletion', true);
  }
  render() {
    return (
      <div>
        <AceEditor
          ref={this.props.type}
          mode={this.props.type}
          theme="monokai"
          width="100%"
          style={{height: this.props.height + 'px'}}
          onChange={(newData, source) => { this.props.codeChange(newData, source, this.props.type) }}
          value={this.props.codeData}
          name="jsEditor"
          editorProps={{$blockScrolling: true}}
          tabSize={2}
          setOptions={{
            enableLiveAutocompletion: false,
            showLineNumbers: true,
            useSoftTabs: true
          }}
          // ONLY DOING THE BELOW TO GET RID OF WARNING MESSAGE
          onLoad={editor => editor.$blockScrolling = Infinity}
        />
        </div>
    );
  }
}

export default AceComponent;



// WEBPACK FOOTER //
// ./src/_AceComponent.js